export const footerText = {
  en: {
    copyright: "All rights reserved.",
    online: "online",
    visitors: "visitors",
    designBy: "Design by",
    withLove: "with ❤️",
  },

  vi: {
    copyright: "Bảo lưu mọi quyền.",
    online: "online",
    visitors: "truy cập",
    designBy: "Thiết kế bởi",
    withLove: "với ❤️",
  },
};
